import React, { Fragment, useState, useEffect, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { MdOutlineListAlt, MdAddCircle } from 'react-icons/md';
import Swal from 'sweetalert2';

import { CRMContext } from '../context/CRMContext';
import clienteAxios from '../../config/axios';
import CotizacionItem from './CotizacionItem';
import FormBuscarCotizacionItem from './FormBuscarCotizacionItem';
import Paginacion from '../layout/Paginacion';

import Spinner from '../layout/Spinner';

function CotizacionItems() {

    const [ items, guardarItems ] = useState([]); 
    const [ cambio, guardarCambio ] = useState(true);
    const [ busqueda, guardarBusqueda ] = useState('');
    const [ filtro, guardarFiltro ] = useState('');
    const [ spin, guardarSpin ] = useState(true);
    const [ cantPaginas, guardarCantPaginas ] = useState(0);
    const [ offset, guardarOffset ] = useState(0);

    const [auth, guardarAuth] = useContext(CRMContext);

    let navigate = useNavigate();

    const pagActual = (numero) => {
        guardarOffset(numero);
    }

    const leerBusqueda = (e) => {
        guardarBusqueda(e.target.value);
    }

    const escucharCambio = () => {
        const inputBuscar = document.querySelector('#buscar');
        if (inputBuscar) {
            inputBuscar.value = "";
        }
        guardarBusqueda('');
        guardarFiltro('');
        guardarOffset(0);
        guardarCambio(!cambio);
    }

    const buscarItem = async (e) => {
        e.preventDefault();

        if(e.nativeEvent.submitter.value === 'Limpiar Filtros'){
            escucharCambio();
            return;
        }

        if(busqueda.length < 3) {
            Swal.fire({
                type: 'error',
                title: 'Hubo un error',
                text: 'Debes tener mínimo 3 caracteres para buscar',
                timer: 1500
            });
            return;
        }

        guardarFiltro(busqueda);
        guardarOffset(0);
        guardarCambio(!cambio);
    }

    const consultarAPI = async () => {
        
        try {
            localStorage.setItem('ultima', `/cotizacion-items`);
            
            const res = await clienteAxios.get(`/cotizacion/items/pagina/${offset}`,{
                headers: {
                    Authorization: `Bearer ${auth.token}`
                },
                params: filtro ? { q: filtro } : undefined
            });

            const lista = res.data.items
                || res.data.cotizacionItems
                || res.data.data
                || [];
            
            guardarCantPaginas(res.data.cantPag ?? res.data.paginas ?? 0);
            guardarItems(Array.isArray(lista) ? lista : []);
            
        } catch (error) {
            console.log(error)
            if(error.response?.status === 404) {
                Swal.fire({
                    type: 'error',
                    title: 'Error!',
                    text: error.response.data.msg,
                    timer: 3500
                });
            }
        }
    }

    useEffect(() => {        
        
        if(auth.token !== '' && auth.tipo === 1) {
            consultarAPI();
            localStorage.removeItem('filtroEmpresa');
            localStorage.removeItem('filtroIngreso');
            localStorage.removeItem('filtroFactura');
            localStorage.removeItem('pagina');
        } else {
            navigate('/login', {replace: true});
        }      
    }, [cambio, offset]);

    setTimeout(() => {
        guardarSpin(false);
    }, 10000);

    return (
        <Fragment>
            <div className="card contenedor">
                <div className="card-header">
                    <MdOutlineListAlt size={50} color={"#333333"}/>
                    <h1>Items de Cotización</h1>
                </div>
                <div className="card-body">

                    <div className='card-body-options'>

                        <FormBuscarCotizacionItem leerBusqueda={leerBusqueda} buscarItem={buscarItem} escucharCambio={escucharCambio}/>

                        <Link to={"nuevo"} type="button" className="btn-new btn-success-new">
                            <MdAddCircle size={25}/>
                            <MdOutlineListAlt size={25}/>
                            Nuevo Item de Cotización
                        </Link>
                    </div>


                    <div className="table-responsive">
                        <table className="table table-hover">
                            <thead>
                                <tr className='table__head'>
                                    <th scope="col">Nombre</th>
                                    <th scope="col">Descripción</th>
                                    <th scope="col">Clave Única</th>
                                    <th scope="col">Valor Actual</th>
                                    <th scope="col">Fecha Valor</th>
                                    <th scope="col">Veces Usado</th>
                                    <th scope="col">Estado</th>
                                    <th scope="col">Editar</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    items.length > 0 ? (
                                        items.map((datos) => (
                                            <CotizacionItem datos={datos} key={datos.id}/>
                                        ))
                                    ) : spin ?
                                    <Spinner/>
                                    :
                                    <tr><td><p className='mensaje-vacio'>Aún no hay ítems de cotización registrados o nadie coincide con la búsqueda </p></td></tr>
                                }
                            </tbody>
                        </table>
                    </div>
                    <Paginacion cantPaginas={cantPaginas} pagActual={pagActual} offset={offset}/>
                </div>
            </div>
        </Fragment>
    )
}

export default CotizacionItems;
